<template>
  <div class="page-code-add-info">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="form-box">
      <el-form-item
        label="代码位名称"
        prop="adslot_name"
      >
        <el-input v-model="form.adslot_name" show-word-limit :maxlength="30" clearable />
      </el-form-item>
      <el-form-item
        label="所属应用"
        prop="media_id"
      >
        <el-select
          v-model="form.media_id"
          placeholder="请选择"
          clearable
          filterable
          :disabled="!!id"
        >
          <el-option
            v-for="item in appOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="渲染方式"
        prop="render_method"
      >
      <el-radio-group v-model="form.render_method">
        <el-radio-button
          v-for="item in renderMethodOptions"
          :key="item.value"
          :label="item.value"
          :disabled="!!id"
        >{{item.label}}</el-radio-button>
      </el-radio-group>
      </el-form-item>
      <el-form-item
        label="创意类型"
        prop="acc_adtype"
        v-if="form.render_method === 1"
      >
        <el-radio-group v-model="form.acc_adtype">
          <el-radio-button
            v-for="item in accAdtypesOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="屏幕方向"
        prop="screen_ori"
      >
        <el-radio-group v-model="form.screen_ori" @change="getStyleList">
          <el-radio-button
            v-for="item in screenOriOptions"
            :key="item.value"
            :label="item.value"
            :disabled="!!id"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="跳过按钮"
        prop="open_screen_skip_button_num"
        v-if="form.render_method === 1"
      >
        <el-radio-group v-model="form.open_screen_skip_button_num">
          <el-radio-button
            v-for="item in skipShowOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="创意交互样式"
        prop="shake_num_switch"
        v-if="form.render_method === 1"
      >
        <el-radio-group v-model="form.shake_num_switch">
          <el-radio-button
            :key="1"
            :label="true"
          >开</el-radio-button>
          <el-radio-button
            :key="0"
            :label="false"
          >关</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.shake_num_switch && form.render_method === 1"
        label="交互样式"
        prop="shake_num"
      >
        <el-radio-group v-model="form.shake_num">
          <el-radio-button
            v-for="item in shakeTypesOptions"
            :key="item.value"
            :label="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="竞价类型"
        prop="bidding_type"
      >
      <el-radio-group
        v-model="form.bidding_type"
        :disabled="!!id"
        @change="handleBiddingTypeChange"
      >
        <el-radio-button
          v-for="item in biddingTypeOptions"
          :key="item.value"
          :label="item.value"
        >{{item.label}}</el-radio-button>
      </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="+form.bidding_type === 2"
        prop="bid_cpm"
        label="CPM价格"
      >
        <el-input
          v-model="form.bid_cpm"
          :disabled="!!id"
        >
          <span class="unit-text" slot="suffix">元</span>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCodeDetail, getAllAppList, getStyleList, doAddCode, doEditCode } from '@/apis/flow.js';
import { RenderMethodModule, RenderMethodModule2, AccAdtypesImage, BiddingTypes, BiddingTypes2, ScreenOri, SkipShow, ShakeTypes } from '@/common/constant'

export default {
  props: {
    codeType: {
      default: ''
    },
  },
  data () {
    return {
      appOptionsMap: {},
      appOptions: [],
      renderMethodOptions: [],
      accAdtypesOptions: [
        ...AccAdtypesImage
      ],
      biddingTypeOptions: [],
      screenOriOptions: [
        ...ScreenOri
      ],
      skipShowOptions: [
        ...SkipShow
      ],
      shakeTypesOptions: [
        ...ShakeTypes
      ],
      rules: {
        adslot_name: [
          { required: true, message: '代码位名称必填' }
        ],
        media_id: [
          { required: true, message: '所属应用必选' }
        ],
        render_method: [
          { required: true, message: '渲染方式必选' }
        ],
        acc_adtype: [
          { required: true, message: '创意类型必选' }
        ],
        screen_ori: [
          { required: true, message: '屏幕方向必选' }
        ],
        bidding_type: [
          { required: true, message: '竞价类型必选' }
        ],
        open_screen_skip_button_num: [
          {
            required: true,
            validator(rule,value,callback){               
              callback();         
            },
            message: '跳过按钮必选'
          }
        ],
        shake_num_switch: [
          {
            required: true,
            validator(rule,value,callback){               
              callback();         
            },
            message: '创意交互样式必选'
          }
        ],
        shake_num: [
          {
            required: true,
            validator(rule,value,callback){               
              callback();         
            },
            message: '交互样式必选'
          }
        ],
        bid_cpm: [
          { required: true, message: 'CPM价格必填' },
          {
            validator(rule,value,callback){   
              const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/           
              if(reg.test(value) && Number(value) > 0){                
                callback();
              }else{                 
                callback(new Error("请输入有效数字"));               
              }             
            },
            message: '仅支持2位小数'
          },
        ]
      },
      form: {
        media_id: '',
        render_method: RenderMethodModule[0].value,
        acc_adtype: AccAdtypesImage[0].value,
        screen_ori: ScreenOri[0].value,
        open_screen_skip_button_num: SkipShow[0].value,
        shake_num_switch: true,
        shake_num: ShakeTypes[2].value,
        bidding_type: BiddingTypes[0].value,
      }
    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    appName () {
      return this.$route.query.appName || ''
    },
  },
  created() {
    this.userInfo = this.$ls.get('userInfo');
    this.renderMethodOptions = this.userInfo.auth.self_render_auth ? RenderMethodModule2 : RenderMethodModule;
    this.biddingTypeOptions = this.userInfo.auth.server_bid_auth ? BiddingTypes2 : BiddingTypes;
  },
  mounted() {
    this.getAllAppList()
    if (this.id) {
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      const { data = {} } = await getCodeDetail({
        id: this.id
      })
      this.form = {
        ...this.form,
        ...data,
        shake_num_switch: !!data.shake_num
      }
      if (['846388', '904828'].includes(this.form.shake_num)) {
          this.form.shake_num = 'nyn';
      }
      this.getStyleList()
    },
    async getAllAppList() {
      const { data = [] } = await getAllAppList({ status: 0 })
      this.appOptions = data
      if (!this.id && !this.form.media_id && data.length === 1) {
        this.form.media_id = data[0].id
      }
      data.forEach(item => {
        this.appOptionsMap[item.id] = item.name
        if (!this.id && item.name === this.appName) {
          this.form.media_id = item.id
        }
      })

      if (this.form.media_id) {
        this.getStyleList()
      }
    },
    async getStyleList() {
      const { data = '' } = await getStyleList({
        media_id: this.form.media_id,
        screen_ori: this.form.screen_ori,
        adslot_type: this.codeType
      });
      this.$set(this.form, 'creative_type_id',  data[0] ? data[0].style_code : '')
    },
    handleBiddingTypeChange() {
      this.$delete(this.form, 'bid_cpm')
    },
    onCancel() {
      this.$router.go(-1);
    },
    async onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
  
          // 渲染方式
          if (this.form.render_method === 2) {
            this.$delete(this.form, 'acc_adtype');
            this.$delete(this.form, 'open_screen_skip_button_num');
            this.$delete(this.form, 'shake_num');
            this.$delete(this.form, 'shake_num_switch');
          }
  
          const data = {
            ...this.form
          }
          if (!data.shake_num_switch) {
            data.shake_num = ''
          }
          delete data.shake_num_switch

          // 交互样式 = 扭一扭(android/ios区分样式号)
          if (data.shake_num === 'nyn') {
            let item = this.appOptions.find(v => v.id === data.media_id);
            if (item) {
              const typeToAdStyleMap = {
                1: '846388', // 安卓
                3: '904828',  // iOS
                5: '904828' // 鸿蒙
              };
              data.shake_num = typeToAdStyleMap[item.type] || data.shake_num;
            }
          }

          if (this.id) {
            const { message = '编辑成功' } = await doEditCode({
              ...data,
              id: this.id,
              type: this.codeType
            })
            this.$message.success(message)
          } else {
            const { message = '创建成功' } = await doAddCode({
              ...data,
              type: this.codeType
            })
            this.$message.success(message)
          }
          this.$router.go(-1);
        } else {
          return false;
        }
      });
    }
  }
}
</script>
